// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product_details_box{
    font-size: large;
}
.product_details_name_box input {
  font-weight: bold;
  color: var(--ColorSecondaryDark);
}
`, "",{"version":3,"sources":["webpack://./src/components/productDetailsEditComponent/productDetailsEditComponent.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC","sourcesContent":[".product_details_box{\n    font-size: large;\n}\n.product_details_name_box input {\n  font-weight: bold;\n  color: var(--ColorSecondaryDark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
